import {Component, Input} from '@angular/core';
import {DropzoneModule} from "ngx-dropzone-wrapper";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgForOf} from "@angular/common";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../../core/services/general.service";
import {EventService} from "../../../../core/services/event.service";

@Component({
  selector: 'app-cancel-event',
  standalone: true,
  imports: [
    DropzoneModule,
    FormsModule,
    NgForOf,
    ReactiveFormsModule
  ],
  templateUrl: './cancel-event.component.html',
  styleUrl: './cancel-event.component.scss'
})
export class CancelEventComponent {
  @Input() confirmAction!: () => void;
  @Input() data: any;

  public cancelEventForm: FormGroup;
  constructor(public modalCancelEvent:NgbModal, private fb:FormBuilder,private generalService:GeneralService, private serviceEvent:EventService) {
    this.cancelEventForm= this.fb.group({
      id:["null"],
      reason_cancellation:["", Validators.required]
    });
  }

  ngOnInit(): void {
    this.cancelEventForm.patchValue({
      id: this.data["idEvent"]
    });
  }

  cancelEvent(){
    if (this.cancelEventForm.valid) {
      this.serviceEvent.cancelEvent(this.cancelEventForm.value).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
              this.cancelForm();
              this.confirmAction();
            }
          },
          (err: any) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      )
    } else {
      this.generalService.showMessage('warn', 'LLene toda la información solicitada');
    }
  }

  cancelForm(){
    this.cancelEventForm.reset();
    this.modalCancelEvent.dismissAll();
  }
}
